import React from 'react';
import {
  func,
  shape,
  string,
} from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexShopSmallEditorialCard.scss';

const AmexShopSmallEditorialCard = (
  {
    baseRequestUrl,
    handleTagging,
    post: {
      image,
      title,
      url,
    },
    tagConfig,
    type,
  }
) => {
  const editorial = tagConfig?.editorial;
  const imgUrl = `${baseRequestUrl}ShopSmall/editorialData/${type}/images/${image}`;
  const editorialEventName = editorial?.spend_and_get?.event_name;
  const query = editorial?.spend_and_get?.utm;
  const hrefValue = {
    pathname: url,
    query,
  };
  const sanitizedTitle = sanitizeString(title);

  return (
    <li className="AmexShopSmallEditorialCard__item">
      <Link
        href={hrefValue}
        variant="article"
        onClick={() => handleTagging(editorialEventName)}
      >
        <div
          className="AmexShopSmallEditorialCard__image"
          style={{
            backgroundImage: `url(${imgUrl})`,
          }}
        />
        <h3
          className="AmexShopSmallEditorialCard__title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizedTitle,
          }}
        />
      </Link>
    </li>
  );
};

AmexShopSmallEditorialCard.propTypes = {
  baseRequestUrl: string.isRequired,
  handleTagging: func.isRequired,
  post: shape({
    image: string.isRequired,
    title: string.isRequired,
    url: string.isRequired,
  }).isRequired,
  tagConfig: shape({
    editorial: shape({
      spend_and_get: shape({
        event_name: string,
        utm: shape({}),
      }),
      buyout: shape({
        event_name: string,
        utm: shape({}),
      }),
    }),
  }).isRequired,
  type: string.isRequired,
};
export default AmexShopSmallEditorialCard;
